import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom'; // Agregamos useLocation para leer la URL
import './perfil.css';
import Drafts from './Drafts';
import Calendario from '../Calendario/Calendario';
import Informacion from './Informacion';
import Estadisticas from './Estadisticas';
import MiPlan from './MiPlan';
import { FaInfoCircle, FaRegSave, FaChartLine, FaStar } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import ChatBot from '../Chatbot/ChatBot';
import axios from 'axios';

const Perfil: React.FC = () => {
  const [perfil, setPerfil] = useState({
    nombre_usuario: '',
    correo_electronico: '',
    foto_perfil: null,
    contraseña_oculta: '',
    plan_actual: '',
    fecha_registro: ''
  });
  const [activeSection, setActiveSection] = useState('Informacion');
  const [error, setError] = useState('');
  const [publications, setPublications] = useState([]);
  const history = useHistory();
  const location = useLocation(); // Obtener el location para leer parámetros
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [fotoPerfil, setFotoPerfil] = useState<string | null>(null);

  useEffect(() => {
    // Función para recuperar la foto de perfil
    const fetchFotoPerfil = async () => {
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

        const response = await axios.get(`${backendUrl}/perfil/recogerfoto`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          responseType: 'blob'
        });

        const imageUrl = URL.createObjectURL(response.data);
        setFotoPerfil(imageUrl);
      } catch (error) {
        console.error('Error al recuperar la foto de perfil:', error);
      }
    };

    fetchFotoPerfil();
  }, []);

  useEffect(() => {
    // Función para cargar los datos del perfil
    const cargarPerfil = async () => {
      try {
        const token = localStorage.getItem('token');
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

        const response = await fetch(`${backendUrl}/perfil`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        });

        if (!response.ok) {
          throw new Error('Error al cargar el perfil');
        }

        const datos = await response.json();
        setPerfil({
          nombre_usuario: datos.nombre_usuario,
          correo_electronico: datos.correo_electronico,
          foto_perfil: datos.foto_perfil,
          contraseña_oculta: '********',
          plan_actual: datos.plan_actual,
          fecha_registro: datos.fecha_registro
        });
      } catch (error) {
        setError('No se pudieron cargar los datos del perfil.');
      }
    };

    const cargarPublicaciones = async () => {
      try {
        const token = localStorage.getItem('token');
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

        const response = await axios.get(`${backendUrl}/publications`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setPublications(response.data);
      } catch (error) {
        console.error('Error fetching publications:', error);
      }
    };

    cargarPerfil();
    cargarPublicaciones();
  }, []);

  // Redirigir a la sección según el parámetro en la URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const section = searchParams.get('section');

    if (section) {
      setActiveSection(section); // Cambiar la sección activa según el parámetro
    }
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('userId');
    history.push('/PantallaInicial');
  };

  const renderActiveSection = () => {
    switch (activeSection) {
      case 'Informacion':
        return (
          <Informacion
            nombreUsuario={perfil.nombre_usuario}
            correoElectronico={perfil.correo_electronico}
            fotoPerfil={fotoPerfil}
            contraseñaOculta={perfil.contraseña_oculta}
            planActual={perfil.plan_actual}
            fechaRegistro={perfil.fecha_registro}
          />
        );
      case 'Estadisticas':
        return <Estadisticas />;
      case 'Borradores':
        return <Drafts />;
      case 'MiPlan':
        return <MiPlan />;
      default:
        return <Informacion nombreUsuario={''} correoElectronico={''} fotoPerfil={''} contraseñaOculta={''} planActual={''} fechaRegistro={''} />;
    }
  };

  function handleDateChange(arg0: number, arg1: number, arg2: number, arg3: number, arg4: number): void {
    throw new Error('Function not implemented.');
  }

  return (
    <div className="contenedor-perfil">
      <Helmet>
        <title>Perfil</title>
      </Helmet>
      <div className="perfil-header">
        <ChatBot />
        <div className="perfil-info">
          {fotoPerfil ? (
            <img src={fotoPerfil} alt="Foto de perfil" className="foto-perfil" />
          ) : (
            <p>Error al cargar la foto de perfil</p>
          )}
          <div className="perfil-detalle">
            <h2>{perfil.nombre_usuario}</h2>
            <h3>Cuenta</h3>
            <p>@{perfil.nombre_usuario}</p>
          </div>
        </div>
        <h3>Opciones</h3>
        <div className='perfil-menu-order'>
          <div className='perfil-menu-order2'>
            <button className={`perfil-menu-item ${activeSection === 'Informacion' ? 'activo' : ''}`} onClick={() => setActiveSection('Informacion')}><FaInfoCircle /> Información</button>
            <button className={`perfil-menu-item ${activeSection === 'Estadisticas' ? 'activo' : ''}`} onClick={() => setActiveSection('Estadisticas')}><FaChartLine /> Estadísticas</button>
          </div>
          <div className='perfil-menu-order2'>
            <button className={`perfil-menu-item ${activeSection === 'Borradores' ? 'activo' : ''}`} onClick={() => setActiveSection('Borradores')}><FaRegSave /> Borradores</button>
            <button id="MiPlan" className={`perfil-menu-item ${activeSection === 'MiPlan' ? 'activo' : ''}`} onClick={() => setActiveSection('MiPlan')}><FaStar /> Planes</button>
          </div>
        </div>
        <button onClick={handleLogout} className="btn-cerrar">Cerrar Sesión</button>

        <h3>Calendario</h3>
        <div className="calendario">
          <Calendario
            selectedDate={selectedDate}
            onDateChange={(date) => handleDateChange(
              date.getFullYear(),
              date.getMonth(),
              date.getDate(),
              date.getHours(),
              date.getMinutes()
            )}
            publications={publications}
          />
        </div>
      </div>

      <div className="perfil-contenido">
        <div className="perfil-drafts">
          <div className="drafts-list">
            <div className="perfil-seccion">
              {renderActiveSection()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Perfil;
